import { isArray } from "lodash";
import baseClass from "./base"

var SEOTOOLS = function () {

  this.setTitle = function (val) {
    if (val == undefined || !val) return;
    $("title").html(val);
    seoToolsClass.setMetaName(val, "dc.title");
    seoToolsClass.setMetaProperty(val, "og:title");
    seoToolsClass.setMetaProperty(val, "twitter:title");
  };

  this.setCharset = function (val) {
    if (val == undefined || !val) return;

    if ($("meta[charset]").length === 0) {
      $("head").prepend('<meta charset="' + val + '">');
    } else {
      $("meta[charset]").attr("charset", val);
    }
  };

  this.setMetaName = function (val, field) {
    if (val == undefined || !val) return;

    var exist = false;
    $("meta[name]").each(function () {
      if ($(this).attr("name").toLowerCase() === field.toLowerCase()) {
        $(this).attr("content", val);
        exist = true;
      }
    });

    if (!exist) {
        $("head").append(
          '<meta name="' + field.toLowerCase() + '" content="' + val + '" />'
        );
    }
  };

  this.setMetaProperty = function (val, field) {
    if (val == undefined || !val) return;

    var exist = false;
    $("meta[property]").each(function () {
      if ($(this).attr("property").toLowerCase() === field.toLowerCase()) {
        $(this).attr("content", val);
        exist = true;
      }
    });

    if (!exist) {
      $("head").append(
        '<meta property="' + field.toLowerCase() + '" content="' + val + '" />'
      );
    }
  };

  this.setLinkRel = function (val, field) {
    if (val == undefined || !val) return;

    var exist = false;
    $("link[rel]").each(function () {
      if ($(this).attr("rel").toLowerCase() === field.toLowerCase()) {
        $(this).attr("href", val);
        exist = true;
      }
    });

    if (!exist) {
      $("head").prepend(
        '<link rel="' + field.toLowerCase() + '" href="' + val + '" />'
      );
    }
  };

  this.setAuthor = function (val) {
    seoToolsClass.setMetaName(val, "author");
  };

  this.setDescription = function (val) {
    seoToolsClass.setMetaName(val, "description");
    seoToolsClass.setMetaProperty(val, "og:description");
    seoToolsClass.setMetaProperty(val, "twitter:description");
  };

  this.setKeyWords = function (val) {
    seoToolsClass.setMetaName(val, "keywords");
  };

  this.setDcLanguage = function (val) {
    if (val == undefined || !val) return;
    seoToolsClass.setMetaName(val, "dc.language");
    $("html").attr("lang",val);
  };

  this.setResourseType = function (val) {
    seoToolsClass.setMetaName(val, "resource-type");
  };

  this.setRevisitAfter = function (val) {
    seoToolsClass.setMetaName(val, "revisit-after");
  }

  this.setRating = function (val) {
    seoToolsClass.setMetaName(val, "rating");
  };

  this.setDcFormat = function (val) {
    seoToolsClass.setMetaName(val, "dc.format");
  };

  this.setUrlCanonical = function (val) {
    seoToolsClass.setLinkRel(val, "canonical");
    seoToolsClass.setMetaProperty(val, "og:url");
    seoToolsClass.setMetaProperty(val, "twitter:url");
  };

  this.setImage = function (val) {
    seoToolsClass.setMetaProperty(val, "og:image");
    seoToolsClass.setMetaProperty(val, "twitter:image");
  };

  this.setAlternateUrls = function (vals) {
    if (vals == undefined) return;
    if (!isArray(vals)) return;
    if (!vals.length) return;

    $("link[rel]").each(function () {
      if ($(this).attr("rel").toLowerCase() != "alternate") return;
      $(this).remove();
    });

    
    for (var i in vals) {
      $("head").prepend(
        '<link rel="alternate" hreflang="' +
          vals[i].hreflang +
          '" href="' +
          vals[i].url +
          '" />'
      );
    }

  };

};

var seoToolsClass = new SEOTOOLS();

export default seoToolsClass;
